module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-month-5-fbe8b3607e7b084e9f8b339eae9a500c.svg";